module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAXCAYAAAA/ZK6/AAAA7ElEQVR42qWUXXHDQAyEP2XyXkNwGRTCUSgDM6gZJBSCwFAMISmCMwO3CLYP1c1oHNu5TPRk61Y/uycdvGKSviRl/VuWdNoDdw5K/t9Kuko6bwVcCzj4Gk/SFN8hnDdAjgFm9uOfb2sBE/C+qNACLfC71lLy8h9VHBbEJWmW1POqmaTR+6yxzyPwDdyAyw4wASczuxWy84MJGCR10TEuLy1K6yK00dk7ly3lBlZGYI4jEM5yzH4II3AB+mV2YDKzaa30XRXn1u2pMZbbdbL50QKlQt6lHGq2bg6D2NYEnB081O51IZ+eeQw2W/kD11UIP6Le1SsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/player-icon.png
// module id = 625
// module chunks = 0 1 2 3 4